/**
 * Ссылки-приглашения в тексте сообщения: klichat.ru/invite/КОД, тестовый сервер, кличат.рф и
 * адрес, с которого открыт клиент. По ним под сообщением встаёт карточка сервера с кнопкой
 * «Присоединиться», а обычное превью такой ссылки прячется, чтобы карточек не было две.
 * Проверяет scripts/invite-links.test.mjs.
 */

const HOSTS = new Set(['klichat.ru', 'www.klichat.ru', 'dev.klichat.ru', 'xn--80apfe1b2a.xn--p1ai', 'кличат.рф'])
// после кода — конец, пробел или знак препинания; «/invite/код/что-то» — уже другая страница
const LINK = /https?:\/\/([^\s/<>()]+)\/invite\/([A-Za-z0-9_-]{2,32})(?![A-Za-z0-9_-])(?!\/[^\s])/g
const PATH = /^\/invite\/([A-Za-z0-9_-]{2,32})\/?$/
// код в `обратных кавычках` и блоках — это текст про ссылку, а не приглашение
const CODE = /```[\s\S]*?```|`[^`\n]+`/g
// больше трёх карточек под одним сообщением — уже спам, а не приглашение
const MAX = 3

function known(host: string, here?: string): boolean {
  const h = host.toLowerCase()
  return HOSTS.has(h) || (here !== undefined && h === here.toLowerCase())
}

const currentHost = () => (typeof location !== 'undefined' ? location.host : undefined)

/** Коды приглашений из текста, по порядку и без повторов. */
export function inviteCodes(content: string, here: string | undefined = currentHost()): string[] {
  const out: string[] = []
  for (const m of content.replace(CODE, ' ').matchAll(LINK)) {
    const code = m[2]!
    if (known(m[1]!, here) && !out.includes(code)) out.push(code)
    if (out.length === MAX) break
  }
  return out
}

/** Ведёт ли адрес на приглашение Кличата — у такого превью своя карточка. */
export function isInviteUrl(url: string, here: string | undefined = currentHost()): boolean {
  try {
    const u = new URL(url)
    return (u.protocol === 'https:' || u.protocol === 'http:') && known(u.host, here) && PATH.test(u.pathname)
  } catch {
    return false
  }
}
